import { useSignal } from "@preact/signals";
import { CalculationPage } from "./CalculationPage";
import { SettingsPage } from "./SettingsPage";
import logoUrl from "../assets/logo-white.svg";

export const App = () => {
  const page = useSignal<"calculation" | "settings">("calculation");

  const navBtn = (active: boolean) =>
    `px-3 py-2 text-sm font-medium border-b-2 transition-colors ${
      active
        ? "text-white border-lw-green"
        : "text-white/70 border-transparent hover:text-white"
    }`;

  return (
    <div>
      <nav className="bg-gradient-to-r from-lw-navy to-lw-navy-deep mb-8">
        <div className="max-w-6xl mx-auto px-4 flex items-center gap-6 h-14">
          <a href="/" className="flex items-center">
            <img src={logoUrl} alt="LearningWell" className="h-7 w-auto" />
          </a>
          <span className="hidden sm:flex items-center gap-3">
            <span className="h-5 w-px bg-white/30" aria-hidden="true" />
            <span className="text-white text-xs font-semibold uppercase tracking-[0.18em]">
              Car Calculator
            </span>
          </span>
          <div className="flex gap-1 ml-auto">
            <button
              className={navBtn(page.value === "calculation")}
              onClick={() => (page.value = "calculation")}
            >
              Calculation
            </button>
            <button
              className={navBtn(page.value === "settings")}
              onClick={() => (page.value = "settings")}
            >
              Settings
            </button>
          </div>
        </div>
      </nav>

      <div className="max-w-6xl mx-auto px-4">
        {page.value === "calculation" ? <CalculationPage /> : <SettingsPage />}
      </div>
    </div>
  );
};
